import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21697cb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "feature-area",
  class: "container home_seven-featured-wrapper pt-100 pb-70 mn-section"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-xl-6 offset-xl-3 col-md-8 offset-md-2",
    "data-cue": "slideInUp"
  }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "section-title mb-35 text-center" }, " Why AI Caption Is The Right Choice For You ")
  ])
], -1))
const _hoisted_3 = { class: "row justify-content-center gx-xxl-5" }
const _hoisted_4 = ["data-aos-delay"]
const _hoisted_5 = { class: "featured-card" }
const _hoisted_6 = { class: "feature-icon d-flex flex-column justify-content-center align-items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "fs-20" }
const _hoisted_9 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-xxl-3 col-lg-4 col-md-6",
          key: feature.id,
          "data-aos": "fade-up",
          "data-aos-duration": "1000",
          "data-aos-delay": feature.dataDelay
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("img", {
                src: feature.iconImage,
                alt: "Image"
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("h3", _hoisted_8, _toDisplayString(feature.title), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(feature.description), 1)
          ])
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}